import { FiEye } from "react-icons/fi";

const ESTADO_ABREVIADO = {
  "GESTIÓN INICIADA": "Iniciada",
  "EN PROCESO": "En proceso",
  "GESTIÓN EN SEGUIMIENTO": "En seguimiento",
  "APROBADO": "Aprobado",
  "RECHAZADO POR FINANCIADOR": "Rechazado",
};

function formatDate(value) {
  if (!value) return "-";
  const date = value.split("T")[0];
  const [y, m, d] = date.split("-");
  return `${d}/${m}/${y}`;
}

function toSentenceCase(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const CardMobile = ({ item, onVerDetalle }) => {
  const estadoLabel =
    ESTADO_ABREVIADO[item.estado?.toUpperCase()] || toSentenceCase(item.estado);

  return (
    <div className="tarjeta--activa shadow mt-2">
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div>
          <span className="resultado-etiqueta">Fecha:</span>
          <span className="resultado-valor">{formatDate(item.fecha)}</span>
        </div>
        <div>
          <span className="resultado-etiqueta">Nombre:</span>
          <span className="resultado-valor">{item.nombreUsuario}</span>
        </div>
        {estadoLabel && (
          <div>
            <span className="resultado-etiqueta">Estado:</span>
            <span className="resultado-valor">{estadoLabel}</span>
          </div>
        )}
        {item.tipoPedido && (
          <div>
            <span className="resultado-etiqueta">Especialidad:</span>
            <span className="resultado-valor">{item.tipoPedido}</span>
          </div>
        )}
      </div>
      <div className="separador" style={{ width: "100%", borderTopWidth: "2px" }}></div>
      <div className="iconos-acciones-tarjeta">
        <FiEye
          size={20}
          className="autorizacion-accion-icon"
          style={{ cursor: "pointer" }}
          onClick={() => onVerDetalle(item)}
        />
      </div>
    </div>
  );
};

export default CardMobile;
